import styled from "styled-components";
const StyledFSSCert = styled.section`
  //png certificate
  &.capture {
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: white;
  }

  &.capture .cert-bg {
    display: none;
  }

  &.capture .tassles {
    display: none;
  }

  &.capture .dlIcon {
    display: none;
  }

  &.capture .canvas-box {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    position: relative;
  }
  &.capture .canvas-amount {
    position: absolute;
    top: 25%;
    font-size: 28px !important;
  }
  &.capture .canvas-name {
    position: absolute;
    top: 63.5%;
    color: var(--lightblue) !important;
    font-size: 28px !important;
  }
`;
export default StyledFSSCert;
